"use client";
import { cn } from "@/utils/helpers";
import { useAppStore } from "@/store/app";
import Button, { ButtonProps } from "@/components/common/Button";
import { SvgIconBurger } from "@/components/common/Svg";
import styles from "../Header.module.css";

export interface HeaderBurgerProps extends ButtonProps {}

export default function HeaderBurger({
	className
} : HeaderBurgerProps) {
	const showMobileMenu = useAppStore(store => store.showMobileMenu);
	const setShowMobileMenu = useAppStore(store => store.setShowMobileMenu);

	const handleClick = () => setShowMobileMenu(!showMobileMenu);

	return (
		<Button
			square
			pressed={showMobileMenu}
			label="toggle navigation menu"
			onClick={handleClick}
			className={cn(
				styles.HeaderBurger,
				className
			)}
		>
			<SvgIconBurger />
		</Button>
	);
}